export const ROLES = {
  ADMIN: "admin",
  PMMA: "pmma",
  SEFAC: "sefac",
  IBAMA: "ibama",
  LAPAS: "lapas",
} as const;

export const USER_STATUS = {
  Enabled: "enabled",
  Disabled: "disabled",
} as const;

export const ROLE_OPTIONS = [
  { value: ROLES.ADMIN, label: "Administrador" },
  { value: ROLES.PMMA, label: "PMMA" },
  { value: ROLES.SEFAC, label: "SEFAC" },
  { value: ROLES.IBAMA, label: "IBAMA" },
  { value: ROLES.LAPAS, label: "LAPAS" },
];
